import { render, staticRenderFns } from "./addInventory.vue?vue&type=template&id=09b90710&scoped=true&"
import script from "./addInventory.vue?vue&type=script&lang=js&"
export * from "./addInventory.vue?vue&type=script&lang=js&"
import style0 from "./addInventory.vue?vue&type=style&index=0&id=09b90710&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b90710",
  null
  
)

export default component.exports